<template lang="pug">
.analise
    h3.titulo-cadastar-foto Status no Flowable
    el-card.card-container(shadow="hover")
      el-row(:gutter="20")
        el-col(:span="24")
            app-label(label="Digite o N° do Processo:")
            el-input(
              v-model="numProcesso",
              placeholder="Digite o número do processo",
              size="small",
              clearable,
              v-mask="'#########/####'"
            )
              el-button.color-default(
                slot="append",
                icon="el-icon-search",
                id='botao-pesquisar',
                @click="pesquisar"
              )
            div.container-botao(v-show="this.processo.perfil != ''")
              h3 Processo {{ ' ' + this.numProcesso }}
              el-button.botao-sinc(
                @click="sincronizar",
                type="secundary",
                id='botao-add'
                :class="{ 'botaoAdd': verificaStatusProcesso() ? false : true }",
                :disabled="verificaStatusProcesso() === true ? true : false"
              )
                span(:class="verificaStatusProcesso() === true ? 'repeat-icon-disabled' : 'repeat-icon'")
                | Sincronizar status
            span.info-status(v-if="verificaStatusProcesso() === true ? true : false") Não é possível sincronizar pois o status já se encontra atualizado
      el-row(:gutter="20")
        el-col(:span="12")
            el-card.card-container(v-if="processo.cpfCnpjInteressado != ''" shadow="hover")
                h3 Dados do Flowable
                .info-item
                    span.info-label Nome do interessado:
                    | {{ ' '  + processo.nomeRazaoSocialInteressado }}
                .info-item
                    span.info-label CPF/CNPJ:
                    | {{ ' ' + processo.cpfCnpjInteressado }}
                .info-item
                    span.info-label Perfil:
                    | {{ ' ' + processoFlowable.perfil }}
                .info-item
                    span.info-label Setor:
                    | {{ ' ' + processoFlowable.setor }}
                .info-item
                    span.info-label Status:
                    | {{ ' ' + processoFlowable.status }}
                .info-item
                    span.info-label Usuário:
                    | {{ processo.usuario ? ' ' + processo.usuario : ' ' + 'Usuário não encontrado'}}
                .alert-container(v-if="this.processo.status != this.processoFlowable.status")
                    .alert-message
                        span.alert-text(style="color: red;") Atenção
                    p.alert-description(style="font-weight: bold;") Divergência de dados detectada entre o Flowable e o banco de dados

        el-col(:span="12")
            el-card.card-container(v-if="processo.cpfCnpjInteressado != ''" shadow="hover")
                h3 Banco de dados
                .info-item
                    span.info-label Nome do interessado:
                    | {{ ' '  + processo.nomeRazaoSocialInteressado }}
                .info-item
                    span.info-label CPF/CNPJ:
                    | {{ ' ' + processo.cpfCnpjInteressado }}
                .info-item
                    span.info-label Perfil:
                    | {{ ' ' + processo.perfil }}
                .info-item
                    span.info-label Setor:
                    | {{ ' ' + processo.setor }}
                .info-item
                    span.info-label Status:
                    | {{ ' ' + processo.status }}
                .info-item
                    span.info-label Usuário:
                    | {{ processo.usuario ? ' ' + processo.usuario : ' ' + 'Usuário não encontrado'}}

</template>

<script>
import AppLabel from '@/components/AppLabel'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import CardProcesso from './components/CardProcesso.vue'
import {buscarProcesso, buscarProcessoFlowable, sincronizarDadosProcesso} from '@/utils/manutencao'

export default {
  components: {
    AppLabel,
    CardProcesso
  },
  data () {
    return {
      numProcesso: '',
      processo: {
        id: null,
        nomeRazaoSocialInteressado: '',
        setor: '',
        status: '',
        usuario: '',
        perfil: '',
        cpfCnpjInteressado: ''
      },
      processoFlowable: {
        setor: '',
        perfil: '',
        status: ''
      }
    }
  },

  mixins: [
    AppNotificacao
  ],

  methods: {

    async pesquisaProcessoBd () {
      const response = await buscarProcesso(this.numProcesso)
      if (response) {
        this.processo = response
      } else {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
          'Erro ao buscar o Processo, verifique o N° do Processo')
      }
    },

    async pesquisaProcessoFlowable () {
      const response = await buscarProcessoFlowable(this.numProcesso)
      if (response) {
        this.processoFlowable = response
      } else {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
          'Erro ao buscar o Processo, verifique o N° do Processo')
      }
    },

    async pesquisar () {
      if (!this.numProcesso || this.numProcesso === '') {
        this.showNotificacao(this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING, 'Preencha o campo N° do Processo')
      } else {
        this.pesquisaProcessoBd()
        this.pesquisaProcessoFlowable()
      }
    },

    async sincronizar () {
      const response = await sincronizarDadosProcesso(this.processo.id)
      if (response) {
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          'Status sincronizado com sucesso.'
        )
        this.pesquisaProcessoBd()
        this.pesquisaProcessoFlowable()
      } else {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
          'Erro ao buscar o Processo, verifique o N° do Processo')
      }
    },

    verificaStatusProcesso () {
      if (this.processo.status === '') {
        return false
      }
      return this.processo.status === this.processoFlowable.status
    }
  }
}
</script>

<style lang="scss" scoped>
  .analise {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .container-botao {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    margin-bottom: 25px;
    margin-top: 25px;
  }

  .info-item {
    display: block;
    margin-bottom: 10px; /* Espaço entre os itens */
  }

  .info-label {
    font-weight: bold;
  }

  .info-status {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-end;
    font-style: italic;
    width: 100%;
  }

  .botao-add {
    font-size: 12px;
    align-items: end;
    color: #009f61;
    border-color: #009f61;
  }

  .card-container {
    margin: 20px;
    border-radius: 10px;
  }

  .alert-container {
    margin-top: 20px;
  }

  .alert-message {
    margin-top: 9px;
  }

  .alert-text {
    color: red;
    font-size: 12pt;
  }

  .alert-description {
    font-weight: bold;
    font-size: 10pt;
  }

  .botao-sinc {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
  }

  .repeat-icon {
   margin-right: 8px;
  }

  .repeat-icon-disabled {
    margin-right: 8px;
    color: #0e0a0a;
  }
</style>



// WEBPACK FOOTER //
// src/screens/manutencao/VerificaStatusProcesso.vue